import axios from 'axios';
import React from 'react';
import { findDOMNode, unmountComponentAtNode } from 'react-dom';
import Form from './Form';
import InactiveBg from '../components/InactiveBg';

export default class ProfileEditor extends React.Component {
  state = {
    errors: {}
  };

  onSubmit = (e, formData) => {
    e.preventDefault();

    if (Object.keys(formData).length === 0) {
      this.close();

      app.features.notification('.js-notification', {
        text: 'Vaše konto bolo úspešne upravené.',
        status: 'success'
      });
    } else {
      formData.action = 'update-profile';
      document.getElementById('loading').style.display = "block";
      axios.post('/p2p/profil/', formData).then((response) => {
        window.location.reload();
      }).catch((error) => {
        document.getElementById('loading').style.display = "none";
        const errors = error.response.data.errors

        this.setState({ errors });
      });
    }
  };

  close = () => {
    // eslint-disable-next-line react/no-find-dom-node
    const thisNode = findDOMNode(this);
    unmountComponentAtNode(thisNode.parentNode);
  };

  onCancel = (e) => {
    e.preventDefault();
    this.close();
  };

  render() {
    const { errors } = this.state;
    const { initProps } = this.props;

    return (
      <InactiveBg>
        <Form onSubmit={this.onSubmit} onCancel={this.onCancel} form={initProps} serverErrors={errors} />
      </InactiveBg>
    );
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/profileEditor/index.js